module.exports = __webpack_public_path__ + "img/16.fe439685.png";